// extracted by mini-css-extract-plugin
module.exports = {"start":"style-module--start--2sdWm","end":"style-module--end--1Qrgs"};